import { render, staticRenderFns } from "./RewardClientDetails.vue?vue&type=template&id=291c771e&"
import script from "./RewardClientDetails.vue?vue&type=script&lang=js&"
export * from "./RewardClientDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports